import {XauditModel} from '../../xaudit.model';

export class FormResultDataModel extends XauditModel {
    dataFormResultId: string;
    dataFormItemId: string;
    Result: string;
    NumResult: number;
}
